import { render, staticRenderFns } from "./departLevelComp.vue?vue&type=template&id=f876ae2a&"
import script from "./departLevelComp.vue?vue&type=script&lang=js&"
export * from "./departLevelComp.vue?vue&type=script&lang=js&"
import style0 from "./departLevelComp.vue?vue&type=style&index=0&id=f876ae2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports